export const CLEAR_COLOR = '#83769C'
export const UPDATES_PER_SECOND = 60
export const BASE_SCALE = 1.28

export const CPU_TURN_DELAY = 1750
export const CPU_MIN_THINK_DELAY = 1250
export const CPU_MAX_THINK_DELAY = 2750

export const LOCAL = 1
export const REMOTE = 2
export const COMPUTER = 3

export const POM_RADIUS = 24
export const ROW_LENGTH = 11
export const HIT_RADIUS = 8

export const VACANT = 0
export const PLAYER_1 = 1
export const PLAYER_2 = 2
export const PLAYER_3 = 3
export const PLAYER_4 = 4
export const SOLID = 5

export const JUMP = 0
export const SPLIT = 1

export const BASIC_BOARD = 0
